'use strict';

intellidealerAppCoreModule.factory('memosResource', function ($resource, appConfigurationService) {
  return {
    myDealerCustomizedMessages: $resource(appConfigurationService.basePath + '/rest/memos/myDealerCustomizedMessages'),
    publicCustomizedMessages: $resource(appConfigurationService.basePath + '/rest/memos/publicCustomizedMessages')
  }
});
